import React from 'react';
import { Plus } from 'react-bootstrap-icons';
import { Button } from "react-bootstrap";

function sanitize(rawProps) {
  const DEFAULT_BUTTON_VARIANT = 'outline-success';
  const DEFAULT_BUTTON_CLASSNAME = 'float-end';

  var props = rawProps || {};

  if (!props.variant) {
    props.variant = DEFAULT_BUTTON_VARIANT;
  }

  if (!props.className) {
    props.className = DEFAULT_BUTTON_CLASSNAME;
  }

  return props;
}

function AddButton(props) {
  const { containerProps: rawProps, title } = props;
  const DEFAULT_BUTTON_TITLE = 'Adicionar';

  var buttonProps = sanitize(rawProps);

  return (
    <Button {...buttonProps}><Plus /> {title || DEFAULT_BUTTON_TITLE}</Button>
  );
}


export default AddButton;